import React from 'react';
import './Boost.css';
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

const Size = () => {

  return (
    <div className="boost-container2">
      <h1 className="large-text3">
        <TranslateText text="TRADELINE SIZE LEGEND" />
      </h1>
      <span className="large-text2">
        <TranslateText text="Small = Opened under 1 year ago" />
      </span>
      <span className="large-text2">
        <TranslateText text="Medium = Opened 1 year to 3 years ago" />
      </span>
      <span className="large-text2">
        <TranslateText text="Large = Opened 3 to 6 years ago" />
      </span>
      <span className="large-text2">
        <TranslateText text="XL = Opened 6 to 12 years ago" />
      </span>
      <span className="large-text2">
        <TranslateText text="Credit limits will vary as we have many high limit credit cards." />
      </span>
    </div>
  );
}

export default Size;


// import React from 'react'
// import './Boost.css'
 

// const Size = () => {
//   return (
//     <div className="boost-container2">
//     <h1 className="large-text3">TRADELINE SIZE LEGEND</h1>
//     <span className="large-text2">Small = Opened under 1 year ago</span>
//     <span className="large-text2">Medium = Opened 1 year to 3 years ago</span>
//     <span className="large-text2">Large = Opened 3 to 9 years ago</span>
//     <span className="large-text2">XL = Opened 9.1 to 20 years ago</span>
//     <span className="large-text2">Credit limits will vary as we have many high limit credit cards.</span>

//   </div>
//   )
// }

// export default Size

